import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

export const Lightbox = ({ open, onClose, children }) => {
  const overlayRef = useRef(null)
  const firstFocusRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const prev = document.activeElement
    firstFocusRef.current?.focus()
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'Tab') {
        const focusable = overlayRef.current?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        if (!focusable || focusable.length === 0) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault() }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault() }
      }
    }
    document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('keydown', onKey); prev && prev.focus && prev.focus() }
  }, [open, onClose])

  if (!open) return null
  return createPortal(
    <div
      ref={overlayRef}
      aria-modal="true"
      role="dialog"
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
      <div className="relative max-w-5xl w-full" role="document">
        <button
          ref={firstFocusRef}
          aria-label="Close"
          onClick={onClose}
          className="absolute -top-3 -right-3 rounded-full bg-white/80 dark:bg-slate-800 p-2 shadow hover:bg-white dark:hover:bg-slate-700 focus:outline-none"
        >
          <span aria-hidden>✕</span>
        </button>
        <div className="rounded-lg overflow-hidden shadow-xl bg-white dark:bg-[#0b1220] dark:text-gray-100">
          {children}
        </div>
      </div>
    </div>,
    document.body
  )
}

export default Lightbox
